// extracted by css-extract-rspack-plugin
export default {"text":"text--tZJjI1Un8knLCj8H"};